







































import { Component, Vue, Prop } from 'vue-property-decorator'
import { BForm, BFormRow, BCol, BFormGroup, BFormInput, BFormSelect, BButton, BIconSearch, BIconArrowCounterclockwise, BFormSelectOption } from 'bootstrap-vue';
import TaskFilterOptions from '@/types/TaskFilterOptions'
import AxiosService from '@/services/axiosService';
import i18n from '../i18n';

@Component({
    components: {
        'b-form': BForm,
        'b-form-row': BFormRow,
        'b-col': BCol,
        'b-form-group': BFormGroup,
        'b-form-input': BFormInput,
        'b-form-select': BFormSelect,
        'b-form-select-option': BFormSelectOption,
        'b-btn': BButton,
        'b-icon-search': BIconSearch,
        'b-icon-arrow-counterclockwise': BIconArrowCounterclockwise
    }
})
export default class TaskFilter extends Vue {
    @Prop() projectId!: string;

    projects: ProjectFilterItem[] = [];
    apiAccessToken = this.$store.state.apiAccessToken;

    taskStatuses: TaskStatus[] = [
        { value: true, text: 'taskStatus.yes' },
        { value: false, text: 'taskStatus.no' }
    ]

    filter: TaskFilterOptions = {
        sequenceOrName: null,
        isActive: true,
        projectId: null
    }

    mounted() {
        this.apiAccessToken = this.$store.state.apiAccessToken;
        this.loadProjects();
        if (this.projectId) {
            this.filter.projectId = this.projectId;
            this.filterList(false);
        }
    }

    filterList(resetFilter: boolean) {
        if (resetFilter) {
            this.filter.sequenceOrName = null;
            this.filter.isActive = true;
            this.filter.projectId = null;
        }
        this.$emit('filter-list', this.filter);
    }

    async loadProjects() {
        try {
            const response = await AxiosService.request<ProjectList>({
                url: `projectslookup`,
                method: 'GET'
            });

            this.projects = response.data.records ?? [];
            this.$emit('load-complete');
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
    }
}

interface ProjectList {
    records: ProjectFilterItem[];
}

interface ProjectFilterItem {
    id: string;
    name: string;
    projectManagerId: string;
}

interface TaskStatus {
    value: boolean | null;
    text: string;
} 
